<script>
export default {
  name: 'Tabs',
  props: {
    value: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>

<template>
  <div class="tabs">
    <div class="tabs__wrapper">
      <div class="tabs__item" v-for="(tab, index) in value" :key="index">
        <RouterLink :to="tab.routerLink" v-slot="{ href, route, navigate, isActive, isExactActive }">
          <slot name="tab" :label="tab.label" :routerLink="{ href, route, navigate, isActive, isExactActive }">
            <a :href="href" class="tabs__item__link" :class="{ 'tabs__item__link--active': isExactActive }">
              <span class="tabs__item__link__wrapper" v-html="tab.label"></span>
            </a>
          </slot>
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .tabs {
    font-family: var(--headings-font-family);
    overflow: hidden;
    position: relative;

    &:after {
      background-image: linear-gradient(to right, rgba(#000, 0) 0%, #000 100%);
      background-repeat: repeat-x;
      bottom: 0;
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 2rem;
      z-index: 50;
    }

    .client-tabs &:after {
      background-image: none;
    }

    &__wrapper {
      display: flex;
      flex-direction: row;
      overflow-x: auto;
      overflow-y: hidden;
    }

    &__item {
      max-width: 180px;
      position: relative;
      width: 100%;

      @for $i from 1 through 20 {
         &:nth-child(#{$i}) &__link:not(&__link--active) {
           z-index: #{20 - $i};
         }
      }

      &:first-child &__link {
        border-radius: 8px 0 0 0;
      }

      &:last-child &__link {
        border-radius: 0 8px 0 0;
      }

      &:after {
        bottom: -1px;
        content: "";
        height: 1px;
        left: 0;
        position: absolute;
        right: 0;
        z-index: 30;
      }

      &__link {
        background-color: var(--app-bg);
        height: 100%;
        min-height: 50px;
        padding: 20px 5px 10px 5px;
        position: relative;
        text-align: center;
        transition: background-color 300ms;
        width: 100%;

        &:after {
          background: inherit;
          bottom: -0.5px;
          content: "";
          left: 100%;
          pointer-events: none;
          position: absolute;
          top: 0;
        }

        &:hover {
          background-color: var(--app-bg);
          text-decoration: none;
        }

        &, &__wrapper {
          align-items: center;
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          justify-content: center;
        }

        &__wrapper {
          color: black;
          font-weight: 900;
          line-height: 1;
          padding: 10px 10px;
          text-transform: uppercase;
          width: 100%;
        }

        html &--active {
          background-color: var(--app-bg);
          z-index: 50;
        }

        &--active &__wrapper {
          background-color: black;
          box-shadow: 0 -0.3px 0 0 currentColor inset, 0 3px 0 0 currentColor;
          color: white;
        }
      }
    }
  }

  @media (min-width: 768px) {
    .tabs__item {
      padding-right: 1.5rem;

      &:after {
        box-shadow: 0 0 1px darken(#DEDACA, 30%);
      }

      &:last-child &__link {
        border-radius: 8px 0 0 0;
      }

      &__link {
        background-color: #DEDACA;
        border-radius: 8px 0 0 0;
        filter: drop-shadow(0 2px 2px darken(#DEDACA, 30%));
        padding: 7px 0 7px 18px;

        &:after {
          mask: url(../assets/tabs-corner.svg) exclude no-repeat;
          mask-size: contain;
          -webkit-mask-box-image: url(../assets/tabs-corner.svg);
          width: 40px;
        }

        &__wrapper {
          background-color: black;
          color: white;
          padding: 2px 14px;
        }

        &--active &__wrapper {
          background-color: transparent;
          color: black;
        }
      }
    }
  }
</style>
